import React from 'react';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';

export const SubmittedClaim = () => {
  return (
    <React.Fragment>
      <RadioGroup
        label="Have you submitted a claim?"
        model="attestation.submitClaim"
        aria-labelledby="radio-provider"
        validators={{
          required: (value) => {
            return !value;
          },
        }}
        required
        display="row"
      >
        <RadioGroup.Radio id="radio-yes" label="Yes" value="Yes">
          Yes
        </RadioGroup.Radio>
        <RadioGroup.Radio id="radio-no" label="No" value="No">
          No
        </RadioGroup.Radio>
      </RadioGroup>
    </React.Fragment>
  );
};
